import { create } from 'zustand'
import type { User, AuthFacility } from '@/types'

interface AuthState {
  user: User | null
  facility: AuthFacility | null
  isAuthenticated: boolean
}

interface AuthActions {
  setAuth: (user: User, facility: AuthFacility) => void
  setUser: (user: User) => void
  setFacility: (facility: AuthFacility) => void
  logout: () => void
}

type AuthStore = AuthState & AuthActions

const initialState: AuthState = {
  user: null,
  facility: null,
  isAuthenticated: false,
}

export const useAuthStore = create<AuthStore>()((set) => ({
  ...initialState,

  setAuth: (user, facility) =>
    set({
      user,
      facility,
      isAuthenticated: true,
    }),

  setUser: (user) => set({ user }),

  setFacility: (facility) => set({ facility }),

  logout: () => set(initialState),
}))
